import request from '@/utils/request'

const url = '/home/statistics/'
const api = {
  getstatistics (data) {
    return request({
      url: url + 'getstatistics',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/statistics.js